module.exports = __webpack_public_path__ + "media/unipod/icon-floor-tiling-white-a3f60fc4.svg";